import axios from "axios";
import { getStoredAccessToken } from "../utils/authStorage";
import { withSubdomainQuery } from "../utils/subdomain";


export const LoginConta = async (obj) => {
    console.log(obj)
    try {
        const url = withSubdomainQuery(`${process.env.REACT_APP_API_URL}v1/auth/login`)
        const response = await axios.post(url, obj)
        sessionStorage.setItem("profile_usuario", response.data.loginResponse)
        sessionStorage.setItem("bearer_token", response.data.token)

        sessionStorage.setItem(`@Token:BetBuilder`, response.data.token)
        const obj2 = JSON.parse(response.data.loginResponse)
        console.log(obj2, "obj")

        const save = async () => {
            localStorage.setItem(`@Email:BetBuilder`, obj2.name)
            localStorage.setItem(`@Nome:BetBuilder`, obj2.name)
            localStorage.setItem(`@Telefone:BetBuilder`, obj2.contact)
        }
        await save()

        return response.data
    } catch (err) {
        throw err
    }
}


export const Deposit = async (value) => {
    let token = getStoredAccessToken()

    const headers = {
        'Referer': process.env.REACT_APP_REFERER_URL,
        'Authorization': `Bearer ${token}`,
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_RESULTS_API_URL}/deposit`, {
            method: "PIX",
            value: value
        }, { headers })
        return response
    } catch (err) {
        throw err
    }
}

export const Withdraw = async (value, password, cpf) => {
    let token = getStoredAccessToken()

    const headers = {
        'Referer': process.env.REACT_APP_REFERER_URL,
        'Authorization': `Bearer ${token}`,
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_RESULTS_API_URL}/withdraw`,
            {
                value: value,
                method: "PIX",
                pix: {
                    type: "CPF",
                    key: cpf
                },
                password: password
            }, { headers })

        return response
    } catch (err) {
        throw err
    }
}


export const Statistics = async () => {
    let token = getStoredAccessToken()

    const headers = {
        'Referer': process.env.REACT_APP_REFERER_URL,
        'Authorization': `Bearer ${token}`,
    };
    const url = `${process.env.REACT_APP_RESULTS_API_URL}/statistics/affiliation-general`
    try {
        const response = await axios.get(url, { headers })
        return response
    } catch (err) {

    }
}

//esse metodo funciona
export const MinhasApostas = async () => {
    let token = getStoredAccessToken()

    const headers = {
        'Referer': process.env.REACT_APP_REFERER_URL,
        'Authorization': `Bearer ${token}`,
    };
    const url = `${process.env.REACT_APP_RESULTS_API_URL}/bet`
    try {
        const response = await axios.get(url, { headers })
        return response
    } catch (err) {
        throw err
    }
}


//esse metodo funciona
export const MeuExtrato = async () => {
    let token = getStoredAccessToken()

    const headers = {
        'Referer': process.env.REACT_APP_REFERER_URL,
        'Authorization': `Bearer ${token}`,
    };
    const url = `${process.env.REACT_APP_RESULTS_API_URL}/transaction?initial_date=2024-01-10T03:00:00.000Z&final_date=2024-01-11T02:59:00.000Z`
    try {
        const response = await axios.get(url, { headers })
        return response
    } catch (err) {
        throw err
    }
}


//esse metodo funciona
export const ListarDepositos = async () => {
    let token = getStoredAccessToken()

    const headers = {
        'Referer': process.env.REACT_APP_REFERER_URL,
        'Authorization': `Bearer ${token}`,
    };
    const url = `${process.env.REACT_APP_RESULTS_API_URL}/deposit?initial_date=2024-01-10T03:00:00.000Z&final_date=2024-01-11T02:59:00.000Z&status=`
    try {
        const response = await axios.get(url, { headers })
        return response
    } catch (err) {
        throw err
    }
}

//esse metodo funciona
export const ListarSaques = async () => {
    let token = getStoredAccessToken()
    console.log(token, " token utilizado no listarsaques")
    const headers = {
        'Referer': process.env.REACT_APP_REFERER_URL,
        'Authorization': `Bearer ${token}`,
    };
    const url = `${process.env.REACT_APP_RESULTS_API_URL}/withdraw?initial_date=2024-01-10T03:00:00.000Z&final_date=2024-01-11T02:59:00.000Z&status=`
    try {
        const response = await axios.get(url, { headers })
        return response
    } catch (err) {
        throw err
    }
}

export const SaldoDisponivel = async () => {
    let token = getStoredAccessToken()

    const headers = {
        'Referer': process.env.REACT_APP_REFERER_URL,
        'Authorization': `Bearer ${token}`,
    };

    const url = `${process.env.REACT_APP_RESULTS_API_URL}/bonus?context=CASINO&active_bonus=true`
    try {
        const response = await axios.get(url, { headers })
        return response
    } catch (err) {
        // localStorage.clear()
        throw err
    }
}


export const LoginUsuario = async (user) => {
    const url = withSubdomainQuery(`${process.env.REACT_APP_API_URL}/v1/auth/login`)

    try {
        const response = await axios.post(url, user)
        return response
    } catch (err) {
        throw err
    }
}


export const VerificaToken = async (token) => {

    const url = `${process.env.REACT_APP_RESULTS_API_URL}/withdraw/availability`
    try {
        const response = await axios.get(url, {
            'Referer': process.env.REACT_APP_REFERER_URL,
            'Authorization': `Bearer ${token}`,
        })
        return response
    } catch (err) {
        throw err
    }
}

export const LoginApi = async (obj) => {
    try {
        const url = withSubdomainQuery(`${process.env.REACT_APP_API_URL}/v1/auth/login`);

        const response = await axios.post(url, JSON.stringify(obj))
        return response
    } catch (err) {
        throw err
    }
}
// {
//     "username": "theofm05",
//     "password": "Senha@123",
//     "auth_code": null,
//     "source": "MOBILE"
// }
